"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createCognitiveServicesSpeechServicesPonyfillFactory;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _AudioConfig = require("microsoft-cognitiveservices-speech-sdk/distrib/lib/src/sdk/Audio/AudioConfig");

var _SpeechServices = _interopRequireDefault(require("web-speech-cognitive-services/lib/SpeechServices"));

function resolveFunction(fnOrValue) {
  return typeof fnOrValue === 'function' ? fnOrValue() : fnOrValue;
}

function createCognitiveServicesSpeechServicesPonyfillFactory(_ref) {
  var audioConfig = _ref.audioConfig,
      authorizationToken = _ref.authorizationToken,
      credentials = _ref.credentials,
      enableTelemetry = _ref.enableTelemetry,
      region = _ref.region,
      speechRecognitionEndpointId = _ref.speechRecognitionEndpointId,
      speechSynthesisDeploymentId = _ref.speechSynthesisDeploymentId,
      speechSynthesisOutputFormat = _ref.speechSynthesisOutputFormat,
      subscriptionKey = _ref.subscriptionKey,
      textNormalization = _ref.textNormalization;

  if (!credentials && (authorizationToken || region || subscriptionKey)) {
    console.warn('botframework-webchat: "authorizationToken", "region", and "subscriptionKey" are deprecated and will be removed on or after 2020-12-17. Please use "credentials" instead.');

    credentials = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!authorizationToken) {
                  _context.next = 6;
                  break;
                }

                _context.next = 3;
                return resolveFunction(authorizationToken);

              case 3:
                _context.t0 = _context.sent;
                _context.t1 = region;
                return _context.abrupt("return", {
                  authorizationToken: _context.t0,
                  region: _context.t1
                });

              case 6:
                _context.t2 = region;
                _context.next = 9;
                return resolveFunction(subscriptionKey);

              case 9:
                _context.t3 = _context.sent;
                return _context.abrupt("return", {
                  region: _context.t2,
                  subscriptionKey: _context.t3
                });

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function credentials() {
        return _ref2.apply(this, arguments);
      };
    }();
  } // HACK: We should prevent AudioContext object from being recreated because they may be blessed and UX-wise expensive to recreate.
  //       In Cognitive Services SDK, if they detect the "end" function is falsy, they will not call "end" but "suspend" instead.
  //       And on next recognition, they will re-use the AudioContext object.


  if (!audioConfig) {
    audioConfig = _AudioConfig.AudioConfig.fromDefaultMicrophoneInput();
    var source = audioConfig.privSource; // This piece of code is adopted from microsoft-cognitiveservices-speech-sdk/common.browser/MicAudioSource.ts.
    // Instead of closing the AudioContext, it will just suspend it. And the next time it is needed, it will be resumed (by the original code).

    source.destroyAudioContext = function () {
      if (!source.privContext) {
        return;
      }

      source.privRecorder.releaseMediaResources(source.privContext);
      source.privContext.state === 'running' && source.privContext.suspend();
    };
  }

  return function () {
    var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        referenceGrammarID = _ref3.referenceGrammarID;

    var ponyfill = (0, _SpeechServices.default)({
      audioConfig: audioConfig,
      credentials: credentials,
      enableTelemetry: enableTelemetry,
      referenceGrammars: referenceGrammarID ? ["luis/".concat(referenceGrammarID, "-PRODUCTION")] : [],
      speechRecognitionEndpointId: speechRecognitionEndpointId,
      speechSynthesisDeploymentId: speechSynthesisDeploymentId,
      speechSynthesisOutputFormat: speechSynthesisOutputFormat,
      textNormalization: textNormalization
    });
    var SpeechGrammarList = ponyfill.SpeechGrammarList,
        SpeechRecognition = ponyfill.SpeechRecognition,
        speechSynthesis = ponyfill.speechSynthesis,
        SpeechSynthesisUtterance = ponyfill.SpeechSynthesisUtterance;
    return {
      SpeechGrammarList: SpeechGrammarList,
      SpeechRecognition: SpeechRecognition,
      speechSynthesis: speechSynthesis,
      SpeechSynthesisUtterance: SpeechSynthesisUtterance
    };
  };
}